import { useCallback } from "react";
import { Button, Modal } from "react-bootstrap";
import SubmitButton from "../components/SubmitButton";
import { serviceToDisplayName } from "../lib/display";

const IntegrationDisconnectConfirmation = ({
  show,
  onConfirm,
  onHide,
  serviceName,
  isSubmitting = false,
  error,
}: {
  show: boolean;
  onConfirm: () => boolean | void | Promise<boolean | void>;
  onHide: () => void;
  serviceName: string;
  isSubmitting?: boolean;
  error?: string;
}) => {
  const onConfirmCombined = useCallback(async () => {
    const succeeded = await Promise.resolve(onConfirm());
    if (succeeded !== false) onHide();
  }, [onConfirm, onHide]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton={!isSubmitting}>
        <Modal.Title>Disconnect Integration</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you would like to disconnect{" "}
        {serviceToDisplayName(serviceName)}? You will no longer be able to view
        or modify data from this service.
        {error ? (
          <div className="text-danger mt-3" role="alert">
            {error}
          </div>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
          Cancel
        </Button>
        <SubmitButton
          label="Confirm"
          variant="danger"
          onClick={onConfirmCombined}
          isSubmitting={isSubmitting}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default IntegrationDisconnectConfirmation;
